/* template */
<template minapp="mpx" xlang="wxml"><div class="scroll-main"><mpx-scroll-view enable-back-to-top :scroll-into-view="(toView)" scroll-y sytle="width:100vw;" scroll-with-animation @scroll="onPageScroll" class="content"><div id="inToView-1" data-id="-1"><slot></slot><div class="orientation_title">字母索引</div><div class="orientation_region"><template v-for="(item, index) in (listMain)"><mpx-view @tap="scrollToViewFn" :data-id="(item.id)" class="orientation_city">{{ item.region }}</mpx-view></template></div></div><div v-for="(group, index) in (listMain)" :key="group['{{group.id}}']" :id="('inToView'+group.id)" :data-id="(group.id)"><div class="address_top">{{ group.region }}</div><div class="scroll-content"><mpx-view v-for="(item, index) in (group.children)" :key="item['{{item.id}}']" @tap="handleClick(item)" class="scroll-content-item"><single-city-card :info="(item)" v-if="(showSingleCity)"/><multi-city-card :info="(item)" v-else/></mpx-view></div></div><div :style='["height: 32px"] | transRpxStyle'></div></mpx-scroll-view><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/4hIuHIrG1l1671782385322.png" @tap="scrollToViewTop" class="list-fixed" v-if="(showAnchorFloat &&  srcollTop)"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m4fc4dc6e"}'>
  .scroll-main
    height 100%
    position relative
  .scroll-content
    display flex
    flex-wrap wrap
    padding 0 16px
    justify-content space-between
    &-item
      width 100%
      padding 15px 0px
      font-size 14px
      font-weight 400
      color #000000
      font-family PingFangSC-Regular
      display flex
      flex-direction row
      border-bottom 1px solid RGBA(0, 0, 0, 0.04)
    &:after
      content ''
      width 99px
      max-width 30%
      border 1px solid transparent
  .content
    box-sizing border-box
    width 100vw
    height 100%
  .location
    width 100%
  .location_top
    height 76rpx
    line-height 76rpx
    background #f4f4f4
    color #606660
    font-size 14px
    padding 0 10px
  .location_bottom
    height 140rpx
    line-height 140rpx
    color #d91f16
    font-size 14px
    border-top 1px #ebebeb solid
    border-bottom 1px #ebebeb solid
    padding 0 10px
    align-items center
    display -webkit-flex
  .address_top
    color #333333
    font-size 14px
    font-family PingFangSC-Semibold
    padding 16px 17px 0px
  .location_img
    width 24px
    height 48rpx
    position absolute
    right 10px
    top 62px
  .add_city
    width 114px
    height 60rpx
    line-height 60rpx
    text-align center
    border 1px solid #ebebeb
    color #000000
    margin-right 10px
  .add_citying
    width 114px
    height 60rpx
    line-height 60rpx
    text-align center
    border 1px solid #09bb07
    color #09bb07
    margin-right 10px
  .orientation
    white-space normal
    display inline-block
    width 22px
    height 50rpx
    font-size 14px
    font-weight bold
    color rgb(88, 87, 87)
    text-align center
  .top
    margin-bottom 3px
  .orientation_region
    padding 12px 16px
    font-size 14px
    display grid
    grid-template-columns repeat(7, 1fr)
    font-family PingFangSC-Regular
    grid-row-gap 7px
    grid-column-gap 8px
    color #999999
    text-align center
    line-height 16px
  .orientation_title
    margin-left 16px
    margin-right 25px
    margin-top 16px
    font-size 14px
    font-weight bold
    color #333
    font-family PingFangSC-Semibold
  .orientation_city
    padding 1px 0
    width 100%
    background #f6f7f8
    border-radius 8px
    height 36px
    line-height 36px
    font-size 14px
    color #000000
    font-family PingFangSC-Regular
  .active
    color #1473FF
  .list-fixed
    position fixed
    bottom 141px
    right 7px
    color #999
    font-size 14px
    height 58px
    width 58px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4fc4dc6e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex4fc4dc6e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex4fc4dc6e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4fc4dc6e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index4fc4dc6e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'multi-city-card':getComponent(require("./multi-city-card.mpx?isComponent&outputPath=components%2Fmulti-city-card6fdc8c0c%2Findex")),'single-city-card':getComponent(require("./single-city-card.mpx?isComponent&outputPath=components%2Fsingle-city-card22628d82%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
